import { IOrder } from "@nju/data-access-portal-order";
import { OrdersTableRow } from "./OrdersTableRow";

interface IOrdersTableProps {
  orders: IOrder[];
}

export function OrdersTable({ orders }: IOrdersTableProps) {
  return (
    <div className="border-2 border-geyser bg-white mx-auto w-full py-1 px-3 from-tablet:py-0 from-tablet:px-4 rounded-[12px]">
      {orders.map((order) => {
        return <OrdersTableRow key={order.id} order={order} />;
      })}
    </div>
  );
}
